/* eslint-disable max-params */
/* eslint-disable complexity */
import { isValid, parse } from "date-fns";
import { ORDER_STATUS } from "../../constants/checkout-constants";

const UNIX_SECONDS_MAX_THRESHOLD = 1e12;
const MS_IN_ONE_SECOND = 1000;

const normalizeUnixTsToMs = (value) => {
    const numericValue = Number(value);

    if (!Number.isFinite(numericValue) || numericValue <= 0) {
        return null;
    }

    // Accept both seconds and milliseconds from backend.
    return numericValue < UNIX_SECONDS_MAX_THRESHOLD ? numericValue * MS_IN_ONE_SECOND : numericValue;
};

const getSlotComparisonTimeMs = (testDriveDetails = {}) => {
    const {
        startTime,
        startTimeUnix,
        startTimeInUnix,
        slotStartTime,
        date,
        from
    } = testDriveDetails || {};

    const tdStartTime = normalizeUnixTsToMs(slotStartTime || startTimeUnix || startTimeInUnix || startTime);

    if (tdStartTime) {
        return tdStartTime;
    }

    const parsedSlotStartDateTime = (date && from) ? parse(`${date} ${from}`, "yyyy-MM-dd hh:mm aa", new Date()) : null;

    return parsedSlotStartDateTime && isValid(parsedSlotStartDateTime) ? parsedSlotStartDateTime.getTime() : null;
};

export const getTestDriveCtaText = (testDriveStatus, virtualTestDriveStatusOrDetails, testDriveDetailsArg = {}, eligibilityConfig = {}) => {
    const isLegacySignature = typeof virtualTestDriveStatusOrDetails === "object" && virtualTestDriveStatusOrDetails !== null;
    const virtualTestDriveStatus = isLegacySignature ? "" : virtualTestDriveStatusOrDetails;
    const testDriveDetails = isLegacySignature ? virtualTestDriveStatusOrDetails : testDriveDetailsArg;
    const { isVTDEligible = false, isHubTDEligible = true } = eligibilityConfig || {};
    const { isVTDOrder = false } = testDriveDetails || {};
    const resolvedStatus = testDriveStatus || virtualTestDriveStatus;
    const isVirtualTdBooked = virtualTestDriveStatus === ORDER_STATUS.BOOKED;
    const slotComparisonTimeMs = getSlotComparisonTimeMs(testDriveDetails);
    const hasSlotPassed = Boolean(slotComparisonTimeMs && Date.now() > slotComparisonTimeMs);
    // todo:vtd use the new order key to switch CTA label for video test drive bookings.
    const shouldShowJoinVideoTd = Boolean(isVirtualTdBooked && isVTDOrder && hasSlotPassed);
    switch (resolvedStatus) {
    case ORDER_STATUS.BOOKED: {
        return shouldShowJoinVideoTd ? "Join Video TD" : "Track booking";
    }
    default: {
        if (isVTDEligible && !isHubTDEligible) {
            return "Live car demo";
        }
        return "Free test drive";
    }
    }

};
